/**
 * Simple storage for deeplink source parameter (OM-17521)
 * This file has no dependencies to avoid circular imports issues
 */

let deeplinkSource: string | null = null;
let deviceId: string | null;
let anonymousId: string | null;
let campaignId: string | null = null;

export function setDeeplinkSource(source: string | null): void {
  deeplinkSource = source;
}

export function getSourceAnalyticsData(): { source?: string } {
  return deeplinkSource ? { source: deeplinkSource } : {};
}

export function setDeviceId(id: string | null): void {
  deviceId = id;
}

export function setCampaignId(id: string | null): void {
  campaignId = id;
}

export function getCampaignAnalyticsData(): { campaign?: string } {
  return campaignId ? { campaign: campaignId } : {};
}

export function setAnonymousId(id: any | null): void {
  anonymousId = id;
}

export function getAnalyticsIds(): { deviceId?: string, anonymousId?: string } {
  const result: { deviceId?: string, anonymousId?: string } = {};
  if (deviceId) {
    result.deviceId = deviceId;
  }
  if (anonymousId) {
    result.anonymousId = anonymousId;
  }
  return result;
}


// WEBPACK FOOTER //
// ./src/providers/analytics/deeplink-source.ts